import { urlFor } from "@/utils/client";
import { IKnowledge } from "@/utils/types";
import Image from "next/image";

export function Knowledge(props: IKnowledge) {
  return (
    <div>
      <div className="flex flex-col items-center component-gap component-padding text-darkGrey text-center">
        <div className="flex flex-col component-gap max-w-5xl">
          <p className="heading">{props.title}</p>
          <p className="">{props.description}</p>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 component-gap">
          {(props.highlights ?? []).map((highlight, i) => {
            return (
              <div
                key={i}
                className="bg-darkGrey w-full text-white p-4 flex flex-col gap-4 items-start text-left"
              >
                {highlight.image?.image && (
                  <Image
                    width={640}
                    height={480}
                    sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                    alt={highlight.image?.caption ?? highlight.label}
                    src={urlFor(highlight.image.image).url()}
                    className="w-full object-cover aspect-[4/3]"
                  />
                )}
                <p className="font-display text-xl">{highlight.label}</p>
                <a
                  className="italic mt-auto"
                  href={highlight.fileURL ? highlight.fileURL : highlight.link}
                >
                  Lees meer
                </a>
              </div>
            );
          })}
        </div>
        {props.items && (
          <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 component-gap">
            {props.items.map((item, i) => {
              return (
                <div
                  key={i}
                  className="flex flex-col items-start justify-start gap-4 w-full"
                >
                  <p className="font-display text-xl">{item.title}</p>
                  <div className="w-full flex flex-col gap-4">
                    {(item.items ?? []).map((item, i) => {
                      return (
                        <a
                          key={i}
                          className="flex items-center justify-between w-full"
                          target="_blank"
                          rel="noreferrer"
                          href={item.fileURL ? item.fileURL : item.link}
                        >
                          <p>{item.label}</p>
                          <Image
                            width={20}
                            height={20}
                            className=""
                            alt={item.fileURL ? `Download icon` : `Arrow icon`}
                            src={item.fileURL ? `/download.svg` : `/arrow.svg`}
                          />
                        </a>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
